export default __webpack_public_path__ + "static/media/2332.2db04700.png";